type MergeOption = "FILE" | "PATTERN" | "HYBRID";

const mergeOptionKeys: MergeOption[] = ["FILE", "PATTERN", "HYBRID"];

const isMergeOption = (value: string): value is MergeOption => {
  return mergeOptionKeys.indexOf(value as MergeOption) > -1;
};

const getMergeOptions = () => {
  return [...mergeOptionKeys];
};

const getMergeOptionDisplayValue = (key: MergeOption): string => {
  switch (key) {
    case "FILE":
      return "Original File";
    case "PATTERN":
      return "Document Start Pattern";
    case "HYBRID":
      return "Hybrid";
    default:
      throw new Error(`Value ${key} is not a MergeOption`);
  }
};

export {
  MergeOption,
  isMergeOption,
  getMergeOptions,
  getMergeOptionDisplayValue,
};
